import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { CustomerDetails, Service } from "0.Mine/3.Interfaces/customerDetails";
import { SafeArgonTypography } from "0.Mine/4.Argon/ArgonComponents";
interface CustomerDetailsProps {
  customerDetails: CustomerDetails;
}

const CustomerDetailsView = ({ customerDetails }: CustomerDetailsProps) => {
  const { t } = useTranslation();

  const getFavouriteEmployee = () => {
    let employee = "";
    customerDetails.bookings.forEach((booking) => {
      booking.serviceDetails.forEach((service) => {
        if (service.details.services.length > 0) {
          employee = service.details.services[0].staffName;
        }
      });
    });
    return employee;
  };

  const getFavouriteService = (): Service | null => {
    // Map to store count of each service using serviceId as the key.
    const serviceCount: { [serviceId: string]: { service: Service; count: number } } = {};

    // Loop through each booking and its service details.
    customerDetails.bookings.forEach((booking) => {
      booking.serviceDetails.forEach((serviceDetail) => {
        serviceDetail.details.services.forEach((service) => {
          if (serviceCount[service.serviceId]) {
            serviceCount[service.serviceId].count++;
          } else {
            serviceCount[service.serviceId] = { service, count: 1 };
          }
        });
      });
    });

    // Determine the service with the highest count.
    let favouriteService: Service | null = null;
    let maxCount = 0;

    for (const key in serviceCount) {
      if (serviceCount[key].count > maxCount) {
        maxCount = serviceCount[key].count;
        favouriteService = serviceCount[key].service;
      }
    }

    return favouriteService;
  };

  return (
    <div>
      <SafeArgonTypography variant="p">
        <b>{t("customerDetails.Name")} </b>
        {customerDetails.client_info?.name} {customerDetails.client_info?.surname}
      </SafeArgonTypography>
      <br />
      <SafeArgonTypography variant="p">
        <b>{t("customerDetails.favouriteStaff")}</b>
        {getFavouriteEmployee()}
      </SafeArgonTypography>
      <br />
      <SafeArgonTypography variant="p">
        <b>{t("customerDetails.totalLifetimeValue")}</b>
        {customerDetails.totalClientPaid}
      </SafeArgonTypography>
      <br />
      <SafeArgonTypography variant="p">
        <b>{t("customerDetails.totalBookings")}</b>
        {customerDetails.bookings.length}
      </SafeArgonTypography>
      <br />
      <SafeArgonTypography variant="p">
        <b>{t("customerDetails.favouriteService")}</b>
        {getFavouriteService()?.serviceName}
      </SafeArgonTypography>
      <br />
    </div>
  );
};

export default CustomerDetailsView;
